import { FC } from 'react';

import Button from 'components/_core/Button';
import { INTERCOM_LAUNCHER_CLASS_NAME } from 'features/Intercom';

import { OpenHelpButtonLinkProps } from './types';

const OpenHelpButtonLink: FC<OpenHelpButtonLinkProps> = ({
  children,
  ...props
}) => {
  // Empty onPress handler as this button link will be handled by Intercom
  const onClick = () => {};
  return (
    <Button
      className={INTERCOM_LAUNCHER_CLASS_NAME}
      onClick={onClick}
      variant="primary"
      {...props}
    >
      {children}
    </Button>
  );
};

export default OpenHelpButtonLink;
